module.exports = __webpack_public_path__ + "img/Sistema Desktop.ac3c56d5.png";